export default __webpack_public_path__ + "static/media/mediterraneansnack@2x.aded50fb.jpg";